import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const ChartIcon = (p: IconProps) => <Icon {...p}><path d="M3 3v18h18" /><path d="m18 9-5 5-4-4-3 3" /></Icon>
